import React, { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  fetchUsualSuspectsEffect,
  inviteCollaboratorsEffect,
} from 'app/store/SongList/effects';
import {
  getProfileSearchLink,
  getSearchProfilesValidations,
} from 'app/store/Profile/selectors';
import { fetchSearchProfilesValidationsEffect } from 'app/store/Profile/effects';
import { getCountries } from 'app/store/Countries/selectors';
import { useFetchValidationSchema, useResource } from 'app/utils/hooks';
import { fetchCountriesEffect } from 'app/store/Countries/effects';
import { getInviteCollaboratorLink } from 'app/store/SongList/selectors';
import { toInviteCollaboratorsPayload } from './utils';
import { AddCollaboratorsFormData } from './types';
import { AddCollaboratorDialogComponent } from './AddCollaboratorDialogComponent';

interface AddCollaboratorDialogProps {
  open: boolean;
  onClose: () => void;
}

export const AddCollaboratorDialog: React.FC<AddCollaboratorDialogProps> = ({
  open,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const inviteCollaboratorLink = useAppSelector(getInviteCollaboratorLink);
  const profilesSearchUrl = useAppSelector(getProfileSearchLink)?.href || '';
  const searchProfilesValidation = useAppSelector(getSearchProfilesValidations);
  const [countriesDDL] = useResource(fetchCountriesEffect, getCountries);
  const { validationSchema } = useFetchValidationSchema({
    link: inviteCollaboratorLink,
  });
  const onInviteCollaborators = useCallback(
    async (data: AddCollaboratorsFormData) => {
      await dispatch(
        inviteCollaboratorsEffect({
          payload: toInviteCollaboratorsPayload(data),
        })
      ).unwrap();
    },
    [dispatch]
  );

  useEffect(() => {
    if (!searchProfilesValidation) {
      dispatch(fetchSearchProfilesValidationsEffect());
    }
    dispatch(fetchUsualSuspectsEffect());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <AddCollaboratorDialogComponent
      open={open}
      onClose={onClose}
      profilesSearchUrl={profilesSearchUrl}
      countriesDDL={countriesDDL || {}}
      onInviteCollaborators={onInviteCollaborators}
      searchProfilesValidation={searchProfilesValidation}
      validations={validationSchema}
    />
  );
};
